import React, { useContext, useState } from "react";
import { useNavigate } from "react-router";
import logoSimio from "../../../assets/favicon.png";
import logoApi from "../../../assets/logoApi.png";
import klaviyo from "../../../assets/logoKlaviyo.png";
import splio from "../../../assets/logoSplio.jpeg";
import shopify from "../../../assets/logoShopify.svg";
import just from "../../../assets/logoJust.png";
import { OverflowFrame, PageHeading } from "../../../externalComponents";
import LoadingSpinner from "../../../externalComponents/LoadingSpinner";
import {
  Description,
  Field,
} from "../../../externalComponents/tailwind/fieldset";
import { Link } from "../../../externalComponents/tailwind/link";
import { Text } from "../../../externalComponents/tailwind/text";
import { createScenarioFromScratch } from "../../../functions/createScenarioFromScratch";
import { CustomerContext } from "../../../providers";

export default function CreateAutomationFromScratchPage() {
  const navigate = useNavigate();
  const { customer, integrations } = useContext(CustomerContext);

  var triggers = {
    "optin-confirmation": {
      title: "Optin confirmation",
      description: "Flow starts when a customer has optin for the first time",
      logo: logoSimio,
      type: "optin-confirmation",
    },
    api: {
      title: "API",
      description: "Flow starts when an API request is made",
      logo: logoApi,
      type: "api",
    },
  };

  if (integrations.shopify) {
    triggers = {
      "just-abandoned-checkout": {
        title: "Abandoned checkout",
        description: "Flow starts when a customer has started a checkout",
        logo: just,
        type: "just-abandoned-checkout",
      },
      "abandoned-cart": {
        title: "Abandoned checkout",
        description: "Flow starts when a customer has started a checkout",
        logo: shopify,
        type: "abandoned-cart",
      },
      "order-confirmation": {
        title: "Order paid",
        description: "Flow starts when an order is processed",
        logo: shopify,
        type: "order-confirmation",
      },
      "order-tracking": {
        title: "Order shipped",
        description: "Flow starts when an order is fulfilled",
        logo: shopify,
        type: "order-tracking",
      },
      "back-in-stock": {
        title: "Back in stock",
        description:
          "Flow starts when a product inventory quantity becomes > 0",
        logo: shopify,
        type: "back-in-stock",
      },
      ...triggers,
    };
  }
  if (integrations.klaviyo) {
    triggers = {
      ...triggers,
      klaviyo: {
        title: "Flow webhook",
        description: "Flow starts whenever you want in a Klaviyo Flow",
        logo: klaviyo,
        type: "klaviyo",
      },
    };
  }
  if (integrations.splio) {
    triggers = {
      ...triggers,
      splio: {
        title: "Flow webhook",
        description: "Flow starts whenever you want in a Splio Flow",
        logo: splio,
        type: "splio",
      },
    };
  }

  return (
    <>
      <PageHeading title="Create new automation" />
      <OverflowFrame>
        <div className="grid grid-cols-2 gap-6 w-full justify-items-center sm:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5 xxl:grid-cols-6  my-6">
          {Object.entries(triggers).map(([key, trigger]) => {
            const [isAutomationCreating, setIsAutomationCreating] =
              useState(false);
            return (
              <div
                className=" hover:cursor-pointer border rounded-customBorderRadius shadow-shadowbuttonmin hover:shadow-shadowbuttonpink"
                key={key}
              >
                <Link
                  onClick={async () => {
                    setIsAutomationCreating(true);
                    let nextPagePath = await createScenarioFromScratch({
                      customerId: customer.id,
                      isAutomation: true,
                      automationTriggerType: trigger.type,
                    });
                    navigate(nextPagePath);
                    setIsAutomationCreating(false);
                    // navigate(
                    //   `/automations/new/from-scratch-template?next_page=${trigger.type}`
                    // );
                  }}
                >
                  <div className="flex flex-col justify-between items-center h-56 w-56 p-5">
                    <div>
                      {isAutomationCreating ? (
                        <LoadingSpinner />
                      ) : (
                        <>
                          <img
                            src={trigger.logo}
                            alt="logo du trigger"
                            className="mx-auto h-16 w-16 object-cover"
                          />

                          <Text className="text-xl text-center mt-3">
                            {trigger.title}
                          </Text>
                        </>
                      )}
                    </div>
                    <Field>
                      <Description className="text-center">
                        {trigger.description}
                      </Description>
                    </Field>
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
      </OverflowFrame>
    </>
  );
}
